import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../services/alerts.service';
import { UserService } from '../../services/user.service';
import { SearchService } from '../../search/services/search.service';
/**
 * Component to save the current search.
 */
@Component({
	selector: 'save-search',
	templateUrl: './save-search.component.html',
	styleUrl: './save-search.component.css'
})
export class SaveSearchComponent implements OnInit {
	@Input() mode: any;
	@Input() searchData: any;
	@Input() savedSearch: any;

	Object = Object;
	LOCALIZATION: any;
	userPermissions: { [key: string]: any } = {};

	input = {
		searchpublic: false,
		searchname: '',
		description: '',
		userName: '',
		notificationSubscriberPrefs: false,
		subscriberEmail: false,
		subscriberNotification: false,
		subscriberDuration: 0,
		subscriberId: -1

	};
	limits = {
		description: 500,
		searchname: 255
	};
	libraries: string = '';
	searchObj = {
		query: '',
		type: '16',
		aoi: '',
		criteria: {} as { [key: string]: any },
		libraries: {} as Record<string, any> | any[]  // Object or Array
	};

	constructor(
		private userService: UserService,
		private alertsService: AlertsService,
		private searchService: SearchService,
		private ngbmodalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.userPermissions = this.userService.getUserPermissionsMap();
		this.initValues();
	}

	initValues(): void {
		try {
			this.searchObj = JSON.parse(this.searchData);
			let type: number = Number(this.searchObj.type) * 1;
			switch (type) {
				case 0:
					this.searchObj.type = "Exact";
					break;
				case 16:
					this.searchObj.type = "Boolean";
					break;
				case 32:
					this.searchObj.type = "Concept";
					break;
				case 64:
					this.searchObj.type = "Pattern";
					break;
			}

			if (this.searchObj.libraries) {
				if (Array.isArray(this.searchObj.libraries)) {
					this.libraries = Object.values(this.searchObj.libraries).join(', ');
				} else {
					this.libraries = Object.keys(this.searchObj.libraries).join(', ');
				}
			}

			if (!this.searchObj.criteria) {
				this.searchObj.criteria = {};
			}
		} catch (e) {
			console.log("Error parsing searchObj from JSON.");
		}

		if (this.mode == "update" || this.mode == "view") {
			this.input = {
				searchpublic: this.savedSearch.isPublic,
				searchname: this.savedSearch.name,
				description: this.savedSearch.description || '',
				notificationSubscriberPrefs: this.savedSearch.notificationSubscriberPrefs ? true : false,
				subscriberEmail: this.savedSearch.notificationSubscriberPrefs ? this.savedSearch.notificationSubscriberPrefs.isEmail : false,
				subscriberNotification: this.savedSearch.notificationSubscriberPrefs ? this.savedSearch.notificationSubscriberPrefs.isNotificationMessage : false,
				subscriberDuration: this.savedSearch.notificationSubscriberPrefs ? this.savedSearch.notificationSubscriberPrefs.duration : 0,
				subscriberId: this.savedSearch.notificationSubscriberPrefs ? this.savedSearch.subscriberId : -1,
				userName: this.savedSearch.userName
			};
		}
	}

	/**
	 * Saves the search or updates the existing saved search.
	 */
	save(): void {
		if (!this.input.searchname) {
			this.alertsService.error({
				message: this.LOCALIZATION.fillAllFields
			});
			return;
		}

		let caller = {
			callerName: 'saveSearch'
		};

		let payload = {
			name: this.input.searchname,
			description: this.input.description,
			isPublic: this.input.searchpublic,
			data: this.searchData,
			subscriptionId: undefined,
			notificationSubscriberPrefs: {}

		};

		if (this.mode == "update" || (this.mode == "view" && this.input.notificationSubscriberPrefs)) {
			if (this.input.notificationSubscriberPrefs) {
				payload.subscriptionId = this.savedSearch.subscriptionId;
				payload.notificationSubscriberPrefs = {
					duration: this.input.subscriberDuration,
					isEmail: this.input.subscriberEmail && !!this.userPermissions['ROLE_USERS_EMAIL'],
					isNotificationMessage: this.input.subscriberNotification
				};
			}
			this.searchService.updateSearch(this.savedSearch.id, payload).then(
				(response: any) => {
					this.alertsService.success({
						message: "The saved search was updated."
					});

					this.ngbmodalService.close({
						result: { answer: 'ok', caller: caller },
						timestamp: new Date(),
					});
				},
				() => {
					this.alertsService.error({
						message: "Could not update the saved search."
					});
				}
			);
		}
		else if (this.mode == "add") {
			this.searchService.saveSearch(payload).then(
				(response: any) => {
					this.alertsService.success({
						message: "The search was saved to Saved Searches."
					});

					this.ngbmodalService.close({
						result: { answer: 'ok', caller: caller },
						timestamp: new Date(),
					});
				},
				() => {
					this.alertsService.error({
						message: "Could not save the search."
					});
				}
			);
		}
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}
}
